import React from 'react';
import styled from 'styled-components';
import { colors, spaces } from '../../lib/styles';
import Paragraph from '../Paragraph';
import Text from '../Text';

export interface Props {
    stats: Stat[];
}

export interface Stat {
    label: string;
    value: number | string;
}

const StyledStatsColumns = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
`;

const Item = styled.div`
    width: 100%;
    padding: ${spaces.space6}px ${spaces.space7}px ${spaces.space5}px ${spaces.space7}px;
    border-color: ${colors.typography.contentBorder};
    border-style: solid;
    border-left-width: 1px;
    border-right-width: 1px;
    border-top-width: 1px;
    border-bottom-width: 0;

    &:first-child {
        border-left-width: 0;
        padding-left: 0;
    }

    &:last-child {
        border-right-width: 0;
        padding-right: 0;
    }
`;

function StatsColumns({ stats }: Props) {
    return (
        <StyledStatsColumns>
            {stats &&
                stats.map((stat, index) => {
                    return (
                        <Item key={index}>
                            <Text baseClass="heading" type="div" variations={['h4', 'no-margin']}>
                                {stat.value}
                            </Text>
                            <Paragraph variations={['soft', 'small', 'no-margin']}>
                                {stat.label}
                            </Paragraph>
                        </Item>
                    );
                })}
        </StyledStatsColumns>
    );
}

export default StatsColumns;
